export const fachzeitschriftenSubmenuData = (windowWidth) =>
  windowWidth >= 1024
    ? [
        {
          type: "SubmenuLink",
          label: "Themen",
          link: "/fachzeitschriften/themen",
        },
        {
          type: "SubmenuLink",
          label: "Redaktion",
          link: "/ueber-uns/redaktion",
        },
        {
          type: "SubmenuLink",
          label: "Mediadaten",
          link: "/ueber-uns/media",
        },
        {
          type: "DropdownMenu",
          label: "Jobs",
          link: "/fachzeitschriften/jobs-in-der-bauwirtschaft",
          page: "ueber-uns",
          dropdown_menu_items: [
            {
              type: "SubmenuLink",
              label: "Ausschreiben",
              link: "/fachzeitschriften/jobs-in-der-bauwirtschaft/stellenanzeige-aufgeben",
            },
          ],
        },
        {
          type: "CTAButton",
          label: "Nachrichten",
          link: "/fachzeitschriften",
        },
      ]
    : []
